import moment from 'moment';
/**
 * Translates a `Partial<Task>` change set into the request payload the task
 * update endpoints expect. Callers always express changes in terms of real
 * `Task` fields; this is the single place where field → API-payload quirks
 * live (previously scattered across use-update-tasks.tsx / sagas).
 *
 * Currently encodes:
 * - `completedAt` → `completedAtActual` as epoch millis (the backend names and
 *   types this field differently from the read model).
 * - `assignee` → slim `{ users: [{ userId }], teams: [{ teamId }] }`. The
 *   collection stores the FULL assignee pojos (so optimistic reads show names
 *   + avatars — see `optionsToFullSquad`), but the update endpoints expect
 *   id-only members, so we slim here at the API boundary.
 */ export const mapTaskChangesToPayload = (changes)=>{
    const { completedAt, assignee, ...rest } = changes;
    const payload = {
        ...rest
    };
    if ('completedAt' in changes) {
        payload.completedAtActual = completedAt == null ? completedAt : moment(completedAt).valueOf();
    }
    if ('assignee' in changes) {
        var _ref, _ref1;
        payload.assignee = {
            users: ((_ref = assignee === null || assignee === void 0 ? void 0 : assignee.users) !== null && _ref !== void 0 ? _ref : []).filter((u)=>(u === null || u === void 0 ? void 0 : u.userId) != null).map((u)=>({
                    userId: u === null || u === void 0 ? void 0 : u.userId
                })),
            teams: ((_ref1 = assignee === null || assignee === void 0 ? void 0 : assignee.teams) !== null && _ref1 !== void 0 ? _ref1 : []).filter((t)=>(t === null || t === void 0 ? void 0 : t.teamId) != null).map((t)=>({
                    teamId: t === null || t === void 0 ? void 0 : t.teamId
                }))
        };
    }
    return payload;
};
/** Strips synthetic / temp fields before POSTing a newly created task. */ export const toCreatePayload = (task)=>{
    const { taskId: _omitTempId, ...rest } = task;
    return {
        ...rest
    };
};
